import React, { useState, useEffect } from 'react';
import USAMap from './USAMap';
import './styles.css';

const red = "#CC0000";

const allStateMapping = {
    "Alabama": "AL",
    "Alaska": "AK",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY",
};
  
const reverseStateMapping = {
"AL": "Alabama",
"AK": "Alaska",
"AZ": "Arizona",
"AR": "Arkansas",
"CA": "California",
"CO": "Colorado",
"CT": "Connecticut",
"DE": "Delaware",
"FL": "Florida",
"GA": "Georgia",
"HI": "Hawaii",
"ID": "Idaho",
"IL": "Illinois",
"IN": "Indiana",
"IA": "Iowa",
"KS": "Kansas",
"KY": "Kentucky",
"LA": "Louisiana",
"ME": "Maine",
"MD": "Maryland",
"MA": "Massachusetts",
"MI": "Michigan",
"MN": "Minnesota",
"MS": "Mississippi",
"MO": "Missouri",
"MT": "Montana",
"NE": "Nebraska",
"NV": "Nevada",
"NH": "New Hampshire",
"NJ": "New Jersey",
"NM": "New Mexico",
"NY": "New York",
"NC": "North Carolina",
"ND": "North Dakota",
"OH": "Ohio",
"OK": "Oklahoma",
"OR": "Oregon",
"PA": "Pennsylvania",
"RI": "Rhode Island",
"SC": "South Carolina",
"SD": "South Dakota",
"TN": "Tennessee",
"TX": "Texas",
"UT": "Utah",
"VT": "Vermont",
"VA": "Virginia",
"WA": "Washington",
"WV": "West Virginia",
"WI": "Wisconsin",
"WY": "Wyoming"
};
  

function makeStatsConfig(states) {
    const config = {};
    
    Object.entries(allStateMapping).forEach(([stateName, abbreviation]) => {
        config[abbreviation] = {};
        config[abbreviation] = { fill: red };
    });

    states.forEach(state => {
        const abbreviation = allStateMapping[state.state_name];
        if (abbreviation) {
            config[abbreviation] = {};
            config[abbreviation] = { fill: "green" };
        }
    });

    return config;
  }

function StateDropdown({ onSelect }) {
    const [states, setStates] = useState([]);
    //const baseUrl = 'http://127.0.0.1:8000'; // use this if developing locally without using docker, ngrok, or prod enviornments
    const baseUrl = process.env.REACT_APP_API_BASE_URL; //this url should be of load balancer in AWS ECS and http://0.0.0.0:8000 for local

    useEffect(() => {
        // fetch('http://127.0.0.1:8000/api/states/')
        fetch(`${baseUrl}/api/states/`)
            .then(response => response.json())
            .then(data => setStates(data))
            .catch(error => console.error('Error fetching states:', error));
    }, []);

    // const handleChange = (event) => {
    //     const selectedStateId = event.target.value;
    //     const selectedState = states.find(state => state.id === Number(selectedStateId));
    //     const selectedStateName = selectedState ? selectedState.state_name : '';
    //     onSelect(selectedStateId, selectedStateName);
    // };

    const statesCustomConfig = makeStatsConfig(states);

    const mapHandler = (event) => {
        // alert(event.target.dataset.name)

        // provided the state names are uniquely mapped to the state Ids in the back-end.
        const selectedStateAbbreviation = event.target.dataset.name
        const selectedStateName=reverseStateMapping[selectedStateAbbreviation]
        const selectedState = states.find(state => state.state_name === selectedStateName);
        const selectedStateId = selectedState ? selectedState.id : '';
        onSelect(selectedStateId, selectedStateName);
    };

    return (
        <div>
            {/* <select className="state-dropdown" onChange={handleChange}>
                <option value="">Select a state</option>
                {states.map(state => (
                    <option key={state.id} value={state.id}>{state.state_name}</option>
                ))}
            </select> */}
            <div className="map-container">
                <USAMap
                    customize={statesCustomConfig} 
                    onClick={mapHandler}
                    width={1000}
                    height={500} 
                />
            </div>
        </div>
    );
}

export default StateDropdown;